import { Component, ComponentFactoryResolver, HostListener } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UpperBarComponent } from './menu-bars/upper-bar.component';
import { MainComponent } from './main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE_CURRENT_LANGUAGE } from './common/consts';

@Component({
  templateUrl: './core-app.component.html'
})
export class CoreAppComponent {

  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              protected compFactResolver: ComponentFactoryResolver,
              private _translateService: TranslateService) {
    
    window["$scope"] = this;
    window["startTime"] = new Date().getTime();

    let svgIcons = [
      'aro', 'bm', 'display-filter', 'bit', 'settings', 'tfp', 'weather', 'playback',
      'map', 'map-3d', 'map-sat', 'map-outline', 'free-drawing', 'ruler', 'home',
      'jump-to', 'bulls-eye', 'second-map', 'maps-filter', 'zones-filter', 'lines-filter',
      'points-filter', 'targets-filter', 'tracks-filter', 'plots-filter', 'sensors-filter'
    ];

    this.setTranslation();

    for (let icon of svgIcons) {
      this.matIconRegistry.addSvgIcon(icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/Images/${icon}-icon.svg`));
    }
    window.addEventListener('beforeunload', () => { console.info('BeforeUnload event') });
  }

  private setTranslation() {
    this._translateService.setDefaultLang('en');
    this._translateService.use('en');
  }

}
